import { Avatar } from './avatar.model';

export enum CompanyOrderStatus {
  INACTIVE = 'inactive',
  ACTIVE = 'active',
}

export enum CompanyInventoryStatus {
  INACTIVE = 'inactive',
  ACTIVE = 'active',
}

export enum OCRStatus {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}

export interface OrderUser {
  id: string;
  name: string;
  email: string;
  avatar: string | Avatar;
  registeredAt: string;
}

export interface Company {
  id: string;
  name: string;
  description: string;
  orderStatus: CompanyOrderStatus;
  inventoryStatus: CompanyInventoryStatus;
  ocrStatus: OCRStatus;
  externalId: string;
  orderUsers: OrderUser[];
  orderGuests: OrderUser[];
}

